import { FormEvent, useState } from 'react';
import Button from '../components/Button';
import './Contact.scss';

interface FormElements extends HTMLFormControlsCollection {
    name: HTMLInputElement,
    pronouns: HTMLInputElement,
    email: HTMLInputElement,
    message: HTMLTextAreaElement
}

const Contact = () => {

    const [status, setStatus] = useState('');

    const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setStatus('sending');

        const form = event.target as HTMLFormElement;
        const formData = new FormData(form);
    
        formData.append("access_key", "ca5b2c2d-6592-4fb8-9780-85cc9f4d24e5");
    
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData
        });
    
        const data = await response.json();
    
        if (data.success) {
          setStatus('success');
          form.reset();
        } else {
          console.log('error', data);
          setStatus(data.message);
        }
    };

    return (
        <section className='contact'>
            <form onSubmit={onSubmit} method="POST">
                <div className='contact-info'>
                    <label htmlFor="contact-name" className="required">Your Name</label>
                    <input type='text' id='contact-name' name='name' required></input>
                    <label htmlFor="contact-pronouns">Your Pronouns</label>
                    <input type='text' id='contact-pronouns' name='pronouns'></input>
                    <label htmlFor="contact-email" className="required">Email Address</label>
                    <input type='email' id='contact-email' name='email' required></input>
                </div>
                <div className='contact-message'>
                    <label htmlFor='contact-message' className="required">Message</label>
                    <textarea placeholder="What can we help with?" name='message' required></textarea>
                </div>
                {/* <!-- Honeypot Spam Protection --> */}
                <input type="checkbox" name="botcheck" className="hidden" />
                {
                    status === 'sending' ? (
                        <p>Sending...</p>
                    ) : (
                        <>
                        <Button 
                            label='Chat Soon'
                            type='submit'
                        />
                        </>
                    )
                }
            </form>
            <a href='https://cal.com/making-biscuits/30min' target='_blank' className='hidden-cta'>
                ...need something on the calendar ASAP?
            </a>
            {status === 'sending' && <p className='notify'>Sending...</p>}
            {status === 'success' && <p className='notify'>Thanks! We'll get back to you in 48 hours.</p>}
            {status === 'error' && <p className='notify'>Oops, something went wrong! Please try again.</p>}
        </section>
    )
}

export default Contact;